import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { DeliveryDatetimePropType } from "./SlotSelectorDatetime";

const SlotSelectorTime = (props) => {
    return (
        <select
            id="delivery-datetime"
            name="delivery-datetime"
            value={props.currentDatetime}
            onChange={(evt) => props.setCurrentDatetime(evt.target.value)}
        >
            {props.slots
                .filter(
                    (slot) => slot.moment.substr(0, 10) === props.currentDate
                )
                .map((slot) => {
                    return (
                        <option
                            key={`datetime-${slot.moment}`}
                            value={slot.moment}
                            {...(!slot.free && { disabled: "disabled" })}
                        >
                            {moment(slot.moment).format("kk:mm")} -{" "}
                            {moment(slot.moment)
                                .add(20, "minutes")
                                .format("kk:mm")}
                        </option>
                    );
                })}
        </select>
    );
};

SlotSelectorTime.propTypes = {
    currentDate: PropTypes.string,
    currentDatetime: PropTypes.string,
    setCurrentDatetime: PropTypes.func,
    slots: PropTypes.arrayOf(PropTypes.shape(DeliveryDatetimePropType)),
};

export default SlotSelectorTime;
